import * as React from 'react';
import { connect } from 'react-redux';
import './LoginForm.scss';
import { Utils } from '@src/utils/Utils';
import { default as Button, IButtonType } from '@src/components/button/Button';
import { IInputType, default as Input } from '@src/components/form/input/Input';
import InnerUiWrap from '@src/components/inner-ui-wrap/InnerUiWrap';
import InnerFooterWrap from '@src/components/inner-footer-wrap/InnerFooterWrap';
import Link from '@src/components/link/Link';
import SmallInfo from '@src/components/small-info/SmallInfo';
import { Actions } from '@src/constants/Constants';
import { ILoginView } from '@src/reducers/LoginReducer';
import { RootState } from '@src/reducers';
import { AppActions } from '@src/actions/AppActions';
import { __ } from '@src/utils/i18Abstract';
import { M } from '@src/controllers/M';
import { PreloaderActions } from '@src/actions/PreloaderActions';

interface IReduxState {
    phoneNumber: string;
    showProvidePin: string;
}

interface IReduxActions {
    initLoading: () => void;
    showPassword: () => void;
    updatePhoneNumber: (phone: string) => void;
    reset: () => void;
}

interface IState {
    password: string;
    passwordValid: boolean;
    usernameValid: boolean;
}

type IAllProps = IReduxState & IReduxActions;

class LoginForm extends React.Component<IAllProps, IState> {
    state = {
        password: '',
        passwordValid: true,
        usernameValid: true,
    };

    componentWillUnmount() {
        const { reset } = this.props;

        reset();
    }

    render() {
        const {
            initLoading,
            showPassword,
            phoneNumber,
            updatePhoneNumber,
            showProvidePin,
        } = this.props;
        const { password, passwordValid, usernameValid } = this.state;

        return (
            <form
                className="LoginForm-wrap"
                action={M.Config.getMansFormAction()}
                method="post"
                onSubmit={e => {
                    this.setState({
                        passwordValid: Boolean(password.length),
                        usernameValid: Boolean(phoneNumber.length),
                    });
                    if (!phoneNumber.length || !password.length) {
                        return e.preventDefault();
                    }
                    initLoading();
                }}>
                <input
                    type="hidden"
                    value={M.Config.getApiKey()}
                    name="_apikey"
                />
                <input type="hidden" value="/" name="_target_path" />

                <InnerUiWrap>
                    {Boolean(showProvidePin) &&
                        <SmallInfo
                            body={showProvidePin}
                            large
                            marginBottom
                        />}
                    <Input
                        name="_username"
                        label={__('inputPhoneUsername')}
                        hasError={!usernameValid}
                        errorLabel={__('warningThisFieldIsMandatory')}
                        value={phoneNumber}
                        onChange={value =>
                            updatePhoneNumber(Utils.removeWhitespace(value))}
                    />

                    <Input
                        name="_password"
                        type={IInputType.password}
                        label={__('inputPassword')}
                        hasError={!passwordValid}
                        errorLabel={__('warningThisFieldIsMandatory')}
                        value={password}
                        noBottomMargin
                        onChange={value => this.setState({ password: value })}
                    />
                </InnerUiWrap>

                <InnerFooterWrap>
                    <Button
                        fat
                        fullWidth
                        title={__('buttonLogin')}
                        type={IButtonType.submit}
                    />

                    <Link
                        small
                        title={__('buttonForgotPassword')}
                        onClick={showPassword}
                    />

                    <SmallInfo body={__('legalLogin')} />

                </InnerFooterWrap>

            </form>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    return {
        phoneNumber: state.userState.phoneNumber,
        showProvidePin: state.userState.showProvidePin,
    };
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        initLoading: () => {
            dispatch(PreloaderActions.isVisible(true));
            dispatch({ type: Actions.IS_LOADING, payload: true });
        },

        showPassword: () =>
            dispatch({
                type: Actions.CHANGE_VIEW,
                payload: ILoginView.forgotPassword,
            }),

        updatePhoneNumber: phone => dispatch(AppActions.updatePhone(phone)),

        reset: () => {
            dispatch(AppActions.updatePhone(''));
            dispatch(AppActions.showProvidePin(false));
        },
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(LoginForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login-overlay/login-tab/login-form/LoginForm.tsx